
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/TermsofService",
      function () {
        return require("private-next-pages/TermsofService.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/TermsofService"])
      });
    }
  